import React from 'react';

import { Box } from '@mui/joy';
import Split from '@uiw/react-split';
import { observer } from 'mobx-react-lite';

import LayoutSettingsWidget from './LayoutSettingsWidget';
import { layoutStore } from './LayoutStore';
import PanelWrapper from './PanelWrapper';

interface LayoutManagerProps {
  children?: React.ReactNode;
}

const LayoutManager: React.FC<LayoutManagerProps> = observer(() => {
  const { layout } = layoutStore;

  const handleHorizontal = (pre: number, next: number, paneNumber: number, save = false) => {
    const prevIndex = paneNumber - 2;
    const nextIndex = paneNumber - 1;
    layoutStore.setTopPanelSizes(prevIndex, nextIndex, pre, next, save);
  };

  const handleVertical = (pre: number, next: number) => {
    layoutStore.setBottomHeight(next);
  };

  return (
    <Box sx={{ width: '100%', height: '100%', position: 'relative' }}>
      <Split mode='vertical' visible style={{ height: '100%' }} onDragEnd={handleVertical}>
        <Split
          visible
          style={{ height: `${100 - layout.bottomHeight}%` }}
          onDragging={(pre, next, paneNumber) => handleHorizontal(pre, next, paneNumber, false)}
          onDragEnd={(pre, next, paneNumber) => handleHorizontal(pre, next, paneNumber, true)}
        >
          {layout.topPanels.map((panel: { id: string; size: number }) => (
            <Box key={panel.id} style={{ width: `${panel.size}%`, minWidth: 150 }}>
              <PanelWrapper panelId={panel.id} />
            </Box>
          ))}
        </Split>
        <Box style={{ height: `${layout.bottomHeight}%`, minHeight: 150 }}>
          <PanelWrapper panelId='simulator' />
        </Box>
      </Split>
      <LayoutSettingsWidget />
    </Box>
  );
});

export default LayoutManager;
